import React from 'react';
import './LowboyTimesheet.scss';
import { LinearProgress } from '@mui/material';
import { roundToAtMost2Decimals } from '../utilities/NumberHelpers';
import _ from 'lodash-es';
import LowboyTimesheetContract from './LowboyTimesheetContract';
import moment from 'moment';

export default class LowboyTimesheetContracts extends React.Component {
    getNewHoursSpent = (startTime, endTime) =>
        roundToAtMost2Decimals(moment(endTime).diff(startTime, 'hours', true));

    recalculateTimeSpent = (lowboyTimesheetContract) => {
        const hoursSpent =
            !lowboyTimesheetContract.startTime ||
            !lowboyTimesheetContract.endTime
                ? 0
                : this.getNewHoursSpent(
                      lowboyTimesheetContract.startTime,
                      lowboyTimesheetContract.endTime
                  );

        lowboyTimesheetContract.hoursSpent = hoursSpent;
    };

    syncStartAndEndTimes = (lowboyTimesheet, lowboyTimesheetContract) => {
        const lowboyTimesheetContracts =
            lowboyTimesheet.lowboyTimesheetContracts;

        for (let i = 0; i < lowboyTimesheetContracts.length - 1; i++) {
            if (lowboyTimesheetContracts[i].id != lowboyTimesheetContract.id) {
                continue;
            }

            if (lowboyTimesheetContracts[i].endTime) {
                lowboyTimesheetContracts[i + 1].startTime =
                    lowboyTimesheetContracts[i].endTime;
            }

            if (i > 0 && lowboyTimesheetContracts[i].startTime) {
                lowboyTimesheetContracts[i - 1].endTime =
                    lowboyTimesheetContracts[i].startTime;
            }
        }

        lowboyTimesheet.lowboyTimesheetContracts.forEach((ltc) =>
            this.recalculateTimeSpent(ltc)
        );
    };

    onTimeUpdated = (lowboyTimesheetContract) => {
        const { lowboyTimesheet, onTimesheetMutated } = this.props;

        if (!lowboyTimesheetContract) {
            return;
        }

        this.syncStartAndEndTimes(lowboyTimesheet, lowboyTimesheetContract);

        onTimesheetMutated(lowboyTimesheet);
    };

    render() {
        const { loading, lowboyAssignments } = this.props;

        const contractIds = _.uniq(
            lowboyAssignments.map((la) => la.lowboyResource?.contractId)
        );

        if (loading) {
            return <LinearProgress variant="indeterminate" color="secondary" />;
        }

        return contractIds.map((contractId) => (
            <LowboyTimesheetContract
                key={contractId}
                {...this.props}
                contractId={contractId}
                onTimeUpdated={this.onTimeUpdated}
            />
        ));
    }
}
